import { Link } from "react-router-dom";

export default function Pricing() {
  return (
    <>
      <section className="hero text-white">
        <div className="row g-3 align-items-center">
          <div className="col-md-8">
            <div className="badge-soft mb-2">Pricing built to scale</div>
            <h1 className="display-6 fw-bold">Simple tiers. No contract traps.</h1>
            <p className="lead">
              Pick the plan that matches your deployment velocity.
            </p>
          </div>
          <div className="col-md-4 text-md-end">
            <div className="pill">
              <i className="bi bi-check2-circle"></i> 14-day trial · No card
            </div>
          </div>
        </div>
      </section>

      <section className="mt-5">
        <div className="row g-4">
          <div className="col-md-4">
            <div className="card-pricing h-100">
              <h5>Starter</h5>
              <div className="price">$29</div>
              <p className="text-muted">Per month, up to 3 team members.</p>
              <ul className="list-unstyled text-muted mb-4">
                <li className="mb-2">
                  <i className="bi bi-check-circle"></i> Core dashboards
                </li>
                <li className="mb-2">
                  <i className="bi bi-check-circle"></i> AI briefs (lite)
                </li>
                <li className="mb-2">
                  <i className="bi bi-check-circle"></i> Email support
                </li>
              </ul>
              <Link className="cta-btn primary d-block text-center" to="/contact">
                Get started
              </Link>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card-pricing h-100 border border-2" style={{ borderColor: "var(--accent-1)" }}>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h5>Growth</h5>
                <span className="badge-soft">Most picked</span>
              </div>
              <div className="price">$79</div>
              <p className="text-muted">Per month, up to 15 team members.</p>
              <ul className="list-unstyled text-muted mb-4">
                <li className="mb-2">
                  <i className="bi bi-check-circle"></i> Everything in Starter
                </li>
                <li className="mb-2">
                  <i className="bi bi-check-circle"></i> Real-time alerts
                </li>
                <li className="mb-2">
                  <i className="bi bi-check-circle"></i> SSO + audit trails
                </li>
                <li className="mb-2">
                  <i className="bi bi-check-circle"></i> Priority support
                </li>
              </ul>
              <Link className="cta-btn primary d-block text-center" to="/contact">
                Start Growth
              </Link>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card-pricing h-100">
              <h5>Enterprise</h5>
              <div className="price">Custom</div>
              <p className="text-muted">For regulated teams needing advanced controls.</p>
              <ul className="list-unstyled text-muted mb-4">
                <li className="mb-2">
                  <i className="bi bi-check-circle"></i> Private cloud or on-prem
                </li>
                <li className="mb-2">
                  <i className="bi bi-check-circle"></i> DLP + data residency
                </li>
                <li className="mb-2">
                  <i className="bi bi-check-circle"></i> Dedicated CSM
                </li>
                <li className="mb-2">
                  <i className="bi bi-check-circle"></i> White-glove onboarding
                </li>
              </ul>
              <Link className="cta-btn secondary d-block text-center" to="/contact">
                Talk to sales
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="mt-5">
        <div className="glass-card">
          <div className="d-flex flex-wrap gap-3 align-items-center justify-content-between">
            <div>
              <h5>Theme flexibility is included</h5>
              <p className="text-muted mb-0">
                Visitors keep control with Brutalist, Retro Grid, or Mono Minimal presets. Your brand
                stays cohesive; contrast and readability stay AA+.
              </p>
            </div>
            <Link className="btn btn-outline-light" to="/features">
              See the UI details
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
